import type { FieldError } from 'react-hook-form'
import { Show } from '../show'

interface InputErrorTextProps {
  error: FieldError | undefined
}

export const InputErrorText = ({ error }: InputErrorTextProps) => {
  return (
    <Show when={!!error?.message}>
      <p className="text-xs text-start mt-1 text-destructive">
        {error?.message}
      </p>
    </Show>
  )
}
